export default "__VITE_ASSET__9e6ec0b2__"